import React from "react";
import styled from "styled-components";
import "../styles/custom.css";

const WrapperDownload = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  background: ${(props) => props.theme};
  border-radius: 0px 0px 0px 100px;
  opacity: 0.9;

  @media screen and (max-width: 576px) {
    display: block;
    height: fit-content;
    border-radius: 0px 0px 0px 0px;
  }

  .LeftSide {
    overflow: hidden;
    max-width: 600px;
    padding: 0px 30px;
    margin-top: 30px;
    height: 360px;

    @media screen and (max-width: 1200px) {
      width: 450px;
    }

    @media screen and (max-width: 768px) {
      height: 300px;
      width: 400px;
    }

    @media screen and (max-width: 576px) {
      padding: 20px;
      width: 100%;
      height: fit-content;
    }
  }

  .text-header {
    color: #ffffff;
    font-size: 80px;
    white-space: nowrap;

    @media screen and (max-width: 1200px) {
      font-size: 30px;
    }

    @media screen and (max-width: 768px) {
      font-size: 20px;
    }

    /* @media screen and (max-width: 576px) {
      font-size: 16px;
    } */
  }

  .text-body {
    > p {
      color: #ffffff;
      font-size: 18px;
    }

    @media screen and (max-width: 1200px) {
      p {
        font-size: 16px;
      }
    }

    @media screen and (max-width: 768px) {
      p {
        font-size: 14px;
      }
    }

    /* @media screen and (max-width: 576px) {
      > p {
        font-size: 10px;
      }
    } */
  }

  .RightSide {
    max-width: 500px;
    margin-right: 10px;

    > img {
      height: 100%;
      box-sizing: border-box;
      width: 100%;
    }

    @media screen and (max-width: 576px) {
      margin-right: 0px;
      max-width: none;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 30px;

      > img {
        width: 200px;
      }
    }
  }
`;

const backgroundTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #E59801 0%, #FAEB57 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const DownloadComponent = ({ download, pageName }) => {
  return (
    <WrapperDownload
      className="w-full mt-5"
      theme={backgroundTheme[pageName].background}
    >
      <div className="LeftSide">
        <div className="text-header font-extra">DOWNLOAD</div>
        <div
          className="text-body font-bold"
          dangerouslySetInnerHTML={{
            __html: download.downloadContent,
          }}
        ></div>
      </div>
      <div className="RightSide flex justify-between w-full">
        <div className="block mr-5">
          <img
            className="mb-3"
            src={download.playStoreBanner}
            alt=""
          />
          <img src={download.playStoreQr} alt="" />
        </div>
        <div className="block">
          <img
            className="mb-3"
            src={download.appStoreBanner}
            alt=""
          />
          <img src={download.appStoreQr} alt="" />
        </div>
      </div>
    </WrapperDownload>
  );
};

export default DownloadComponent;
